import React from "react";
import "./styles.scss";

const Disclaimer = (props) => {
  const { content } = props;
  return (
    <div className="Disclaimer comp-wrap flex-it flex-align-item-center flex-justify-center">
      <div className="comp-cont flex-it flex-align-item-center flex-justify-center">
        {content}
      </div>
    </div>
  );
};

export default Disclaimer;
